// You can customize the template with the help of this file
// App logo is served from a URL so it can be changed without a rebuild of assets
export const APP_LOGO_URL = "https://msil-wa.rezo.ai/smrwhatsapp/MS_new_logo.jpg";
//Template config options
const themeConfig = {
  app: {
    appName: "MSIL",
    appLogoImage: APP_LOGO_URL,
  },
  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    routerTransition: "fadeIn", // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: "vertical", // vertical, horizontal
    contentWidth: "full", // full, boxed
    menu: {
      isHidden: false, // true
      isCollapsed: true,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "floating", // static , sticky , floating, hidden
      backgroundColor: "white", // BS color options [primary, success, etc]
    },
    footer: {
      type: "hidden", // static, sticky, hidden
    },
    customizer: false, // false
    scrollTop: false, // Enable scroll to top button
  },
};

export default themeConfig;
